import React, { useEffect, useState, forwardRef, useImperativeHandle, useRef } from 'react';

import { 
	empty
} from '__globals/global-functions';

export const CustomText = props => {
	
	/* LOCAL VARIABLES */
	const [currentValue, setCurrentValue] = useState('');
	const onChangeCurrentValue = e => { setCurrentValue(e.target.value) }

	const [tabIndex, setTabIndex] = useState(1);
	
	const [placeholder, setPlaceholder] = useState("CUSTOM TEXT");
	
	const [errorMsgRequired, setErrorMsgRequired] = useState("Please include your custom text.");
	
	const [required, setRequired] = useState(false);
	
	const [subName, setSubName] = useState("subName");

	const [regExVal, setRegExVal] = useState( "" );

	const [errorMsgRegEx, setErrorMsgRegEx] = useState("Your regex test failed.");

	
	/* FUNCTIONS */
	/* Checks the validations for this element */
	const checkValidation = () => {
		//alert("checking Validation")
		if ( required ) {
			if ( empty(currentValue) ) {
				return errorMsgRequired;
			}
		}
		if ( !empty(regExVal) ) {
			let regex = new RegExp(regExVal, 'i');
			if( regex.test( currentValue ) == false ){
				return errorMsgRegEx;
			}
		}
		return null;
	}
	

	/* HOOKS */
	/* Check validation and send data to the parent whenever the currentValue changes */
	// TODO - SEEMS TO BE A SEQUENCE ISSUE WHERE 'REQUIRED' CANNOT BE SET FROM CONFIG?
	useEffect(() => {
		//alert("called")
		let valMessage = checkValidation();
		//alert(valMessage)
		let isValid = true;
		if ( !empty(valMessage) ) {
			isValid = false;
		}
		let vJSON = {};
		vJSON.name = props.name;
		vJSON.subName = props.fieldsInUse[props.name].subName;
		vJSON.subKey = props.fieldsInUse[props.name].subKey;
		vJSON.val = currentValue;
		vJSON.isValid = isValid;
		vJSON.valMessage = valMessage;
		props.updateFormValues( vJSON );
	}, [currentValue, errorMsgRequired] );
	
	/* Set additional fields from the promotion "fieldsInUse" config */
	useEffect(() => {
		if ( !empty(props.fieldsInUse) && !empty(props.fieldsInUse[props.name]) ) {
			let subName = props.fieldsInUse[props.name].subName;
			setSubName( subName );
			if ( !empty(props.fieldsInUse[props.name].placeholder) && !empty(props.language) ) {
				setPlaceholder( props.fieldsInUse[props.name].placeholder[props.language] );
			}
			if ( !empty(props.fieldsInUse[props.name].errorMsgRequired) && !empty(props.language) ) {
				setErrorMsgRequired( props.fieldsInUse[props.name].errorMsgRequired[props.language] );
			}
			if ( !empty(props.fieldsInUse[props.name].required) ) {
				//alert(props.fieldsInUse[props.name].required)
				setRequired( props.fieldsInUse[props.name].required );
			}
			if ( !empty(props.fieldsInUse[props.name].tabIndex) ) {
				setTabIndex( props.fieldsInUse[props.name].tabIndex );
			}
			if ( !empty(props.fieldsInUse[props.name].regularExpression) ) {
				setRegExVal( props.fieldsInUse[props.name].regularExpression );
			}
			if ( !empty(props.fieldsInUse[props.name].errorMsgRegEx) && !empty(props.language) ) {
				setErrorMsgRegEx( props.fieldsInUse[props.name].errorMsgRegEx[props.language] );
			}
		}
	}, [props.fieldsInUse] );
	
	return (
		<div id={"dv_" + props.name} className={"cls-" + props.name}>
			<input 
				name={props.name}
				type="text" 
				tabIndex={tabIndex} 
				placeholder={placeholder}
				value={currentValue} 
				onChange={onChangeCurrentValue} 
			/>
		</div>
	);
		

}

export default CustomText;

